<script>
    import parseDate from "@/assets/plugins/mps-common/time/parse-date";

    export default {
        name: "CoreDate",
        computed: {
            locale() {
                const user = this.$userManager.user;
                let code = user.languageCode ? user.languageCode : 'en';
                if (user.countryCode) {
                    code += '-' + user.countryCode; // e) ?? -> ??-KR
                }
                return code;
            }
        },
        methods: {
            /**
             * innerType, endOf에 따른 ISO 날짜를 반환합니다.
             *
             * @param date
             * @param type
             * @returns {string|string|null|*}
             */
            toInnerISODate(date, type = "day") {
                const parsed = parseDate(date);
                const luxon = parsed || null;

                if (luxon === null) return null;

                if (type === 'month') {
                    return luxon.toISOMonth();
                } else {
                    return luxon.toISODate();
                }
            },

            toISO(date) {
                const parsed = parseDate(date);
                const luxon = parsed || null;

                if (luxon === null) return null;

                return luxon.toISO();
            },

            endOfISO(date, type) {
                let endOfDatetime = this.endOf(date,type);
                return endOfDatetime ? endOfDatetime.toISO() : null;
            },

            endOf(date, type) {
                const parsed = parseDate(date);
                const luxon = parsed || null;

                if (luxon === null) return null;

                return luxon.endOf(type);
            }
        }
    }
</script>
